import Domain from 'helpers/Domain';
import {
    USER_PROFILES,
    ENHANCED_KIDS_PRIVACY_ENABLED,
    SWITCH_PROFILE_PIN_ENABLED,
    SCREENTIME_LIMIT_ENABLED,
    RESELLER_DELTA_JOURNEY,
    RESELLER_DELTA_JOURNEY_SIGN_IN,
    RESELLER_DELTA_JOURNEY_SIGN_UP,
    RESELLER_DELTA_JOURNEY_DEEPVIEW,
    RESELLER_DELTA_AUTO_LOGIN,
    UPGRADE_ANNUAL_TOGGLE,
    UPSELL_PLANS_ANNUAL,
    // START TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
    PLAN_WITH_SHO_PRESELECTED,
    PLAN_WITH_SHO_PRE_SELECTED_ONE_CTA,
    // END TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
} from 'helpers/featureConstants';
import { AVATARS_V2, RECAPTCHA } from 'helpers/featureConstants';
import { FLOW_TYPE, PARTNER_USING_RECAPTCHA } from '../../../models/FlowModel';
import { RECAPTCHA_FORMS } from '../../../recaptcha/Recaptcha';

export default {
    namespaced: true,

    state: {
        user_profiles: false,
        avatars_v2_enabled: false,
        switch_profile_pin_enabled: false,
        enhanced_kids_privacy_enabled: false,
        screentime_limit_enabled: false,
        [AVATARS_V2]: false,
        [RESELLER_DELTA_JOURNEY]: false,
        [RESELLER_DELTA_JOURNEY_SIGN_IN]: false,
        [RESELLER_DELTA_JOURNEY_SIGN_UP]: false,
        [RESELLER_DELTA_AUTO_LOGIN]: false,
        [UPGRADE_ANNUAL_TOGGLE]: false,
        [UPSELL_PLANS_ANNUAL]: false,
        // START TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
        [PLAN_WITH_SHO_PRESELECTED]: false,
        [PLAN_WITH_SHO_PRE_SELECTED_ONE_CTA]: false,
        // END TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
    },

    mutations: {
        setFeatureFlags: function (state, features) {
            Object.keys(features)
                .sort()
                .forEach((feature) => {
                    state[feature] = features[feature];
                });
        },
        setAvatarsFlagV2: function (state, flag) {
            state.avatars_v2_enabled = flag;
        },
        enableFeature: function (state, featureName) {
            state[featureName] = true;
        },
        setAnnualToggle: function (state, bool) {
            state[UPSELL_PLANS_ANNUAL] = bool;
        },
    },

    actions: {},

    getters: {
        // alias for isEnabled
        isActive: (state, getters) => (featureFlag) => {
            return getters.isEnabled(featureFlag);
        },
        isEnabled: (state) => (featureFlag) => {
            return state[featureFlag] ? state[featureFlag] : false;
        },
        getFlagAvatar: (state) => {
            return state[AVATARS_V2];
        },

        // recaptcha
        isRecaptchaEnabled: (state, getters) => {
            return getters.isEnabled(RECAPTCHA);
        },
        recaptchaFormActionEnabled: (state, getters) => (formAction) => {
            const featureFlag = RECAPTCHA + '_' + formAction.toLowerCase();
            return getters.isEnabled(featureFlag);
        },
        isRecaptchaPartnerEnabled: (state, getters, rootState, rootGetters) => (action) => {
            if (getters.isValidRecaptchaPartnerFormAction(action)) {
                if (getters.partnerAllowedForSkip(rootGetters['flow/type'])) {
                    const recaptchaPartnerFeatureFlag =
                        getters.generateRecaptchaPartnerFeatureFlagByPartnerFlowType(action);
                    return getters.isEnabled(recaptchaPartnerFeatureFlag);
                }
            }
            return true;
        },
        generateRecaptchaPartnerFeatureFlagByPartnerFlowType: (
            state,
            getters,
            rootState,
            rootGetters,
        ) => {
            return RECAPTCHA + '_partner_' + rootGetters['flow/type'];
        },

        partnerAllowedForSkip: (state, getters) => (partner) => {
            const allowedPartnerList = Object.values(PARTNER_USING_RECAPTCHA);
            return allowedPartnerList.includes(partner);
        },
        isValidRecaptchaPartnerFormAction: (state, getters) => (action) => {
            return (
                action === RECAPTCHA_FORMS.FORM_PARTNER_SIGN_IN ||
                action === RECAPTCHA_FORMS.FORM_PARTNER_SIGN_UP
            );
        },

        requirePinToSwitchProfile: (state) => {
            if (Domain.isInternational()) {
                return state[USER_PROFILES] && state[ENHANCED_KIDS_PRIVACY_ENABLED];
            }

            return state[SWITCH_PROFILE_PIN_ENABLED];
        },
        screentimeLimitEnabled: (state) => {
            return (
                state[USER_PROFILES] &&
                state[ENHANCED_KIDS_PRIVACY_ENABLED] &&
                state[SCREENTIME_LIMIT_ENABLED]
            );
        },

        deltaJourneyEnabled: (state) => {
            return state[RESELLER_DELTA_JOURNEY];
        },

        deltaJourneySignInEnabled: (state, getters) => {
            return getters.deltaJourneyEnabled && state[RESELLER_DELTA_JOURNEY_SIGN_IN];
        },

        deltaJourneySignUpEnabled: (state, getters) => {
            return getters.deltaJourneyEnabled && state[RESELLER_DELTA_JOURNEY_SIGN_UP];
        },
        deltaAutoLoginEnabled: (state, getters) => {
            return state[RESELLER_DELTA_AUTO_LOGIN];
        },
        upgradeAnnualToggle: (state) => {
            return state[UPGRADE_ANNUAL_TOGGLE];
        },
        upsellPlansAnnualEnabled: (state, getters, rootState) => {
            return state[UPSELL_PLANS_ANNUAL];
        },
        // START TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
        isShoPlanPreSelected: (state) => {
            return state[PLAN_WITH_SHO_PRESELECTED];
        },
        isShoPlanPreSelectedOneCTA: (state) => {
            return state[PLAN_WITH_SHO_PRE_SELECTED_ONE_CTA];
        },
        isPreSelectAbTest: (state, getters) => {
            return getters.isShoPlanPreSelected || getters.isShoPlanPreSelectedOneCTA;
        },
        // END TEST PLOCTOPLUS-2890: A/B TEST: Pre-Select Paramount+ with SHO Plan
    },
};
